module.exports = __webpack_public_path__ + "static/img/logo.b0bfb71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 635
// module chunks = 1